import gql from 'graphql-tag';

export const ARTICLE_WITH_CREATIVES_QUERY = gql`
  query ArticleWithCreativesQuery($id: ID!) {
    article(id: $id) {
      id
      creatives {
        id
        linkHeadline
        postText
        reviewStatus
      }
    }
  }
`;
